import { Lesson } from '@/models/lesson';
import { LessonFolder } from '@/models/lessonFolder';

export type ContextualItem = Lesson | LessonFolder;

export type PointerPosition = {
    mouseX: number;
    mouseY: number;
};

export function isPointerPosition(pos: unknown): pos is PointerPosition {
    return typeof pos === 'object' && pos !== null && 'mouseX' in pos && 'mouseY' in pos;
}
